import { TComponentsConfigs } from "components/ComponentRenderer";
import { NewsCardComponent } from "components/news/newsCard/NewsCardComponent";
import { LatestNewsSliderComponent } from "components/news/latestNewsSlider/LatestNewsSliderComponent";

export const NEWS_COMPONENTS_CONFIGS: TComponentsConfigs = {
    newsCard: { component: NewsCardComponent },
    latestNews: { component: LatestNewsSliderComponent },
};
